<template>
  <v-navigation-drawer
    class="pt-5"
    width="500"
    :temporary="true"
    location="right"
    v-model="flowsTrigger"
    @update:modelValue="flowsTrigger = $event"
    :absolute="true"
    :scrim="true"
    :disable-resize-watcher="true"
    :disable-route-watcher="true"
  >
    <v-list :lines="'two'">
      <v-sheet class="mx-4" v-if="flows.length === 0">
        {{ $t("labels.no-flows") }}
      </v-sheet>
      <v-list-item v-for="item in flows" :key="item.name">
        <v-list-item-title>{{ item.name }}</v-list-item-title>
        <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
        <template v-slot:append>
          <v-list-item-action>
            <v-icon @click="rerouteToFlow(item._id)" small color="#C8004B"
              >mdi-chevron-right-circle
            </v-icon>
          </v-list-item-action>
        </template>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import SidebarFlow from "@/mixins/SidebarFlow";
import utils from "@/mixins/utils";
import events from "@/mixins/events.js";

export default {
  name: "SidebarFlow",
  props: { mashupsEditorAppbarConfig: {}, realm: String, drawerFlow: Boolean },
  mixins: [utils, events, SidebarFlow],
  emits: ["drawerFlow"],
  computed: {
    flowsTrigger: {
      get() {
        return this.drawerFlow;
      },
      set(value) {
        this.$emit("update:drawerFlow", value);
      },
    },
  },
  methods: {
    rerouteToFlow(id) {
      this.$router.push({
        path: `/flow-editor/` + id,
      });
    },
  },
};
</script>

<style scoped>
.v-navigation-drawer {
  box-shadow: none !important;
  height: calc(100% - 104px) !important;
}
</style>
